import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const collections = ['indoor', 'outdoor', 'pro', 'arc', 'flex', 'tronix', 'sys', 'deco', 'acoustic', 'ville', 'brick'];

export const MobileCollectionSelector = ({ collection, onChange }) => (
  <div data-testid="catalog-mobile-collection-control" className="lg:hidden flex items-center gap-3">
    <span className="text-sm font-medium">Collection</span>
    <Select value={collection || 'all'} onValueChange={value => onChange(value === 'all' ? '' : value)}>
      <SelectTrigger data-testid="catalog-mobile-collection-selector" aria-label="Collection" className="h-10 flex-1"><SelectValue /></SelectTrigger>
      <SelectContent data-testid="catalog-mobile-collection-menu">
        <SelectItem data-testid="catalog-mobile-collection-all" value="all">All collections</SelectItem>
        {collections.map(name => <SelectItem key={name} data-testid={`catalog-mobile-collection-${name}`} value={`lumi-${name}`}>Lumi {name === 'sys' ? 'Sys' : name[0].toUpperCase() + name.slice(1)}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);